import type { CommissionStatus } from '@/types/commission';
import type { BadgeProps } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface OrderStatusBadgeProps extends BadgeProps {
  status?: CommissionStatus;
}

// Map commission status values to color palettes
const statusColorMap: Record<CommissionStatus, string> = {
  paid: 'green',
  pending: 'yellow',
  processing: 'blue',
  cancelled: 'red',
};

const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status, ...props }) => {
  const { t } = useTranslation();

  if (!status) return null;

  const colorPalette = statusColorMap[status] || 'gray';
  const text = t(`orders.status.${status}`, status.charAt(0).toUpperCase() + status.slice(1));

  return (
    <Badge colorPalette={colorPalette} variant="subtle" {...props}>
      {text}
    </Badge>
  );
};

export default OrderStatusBadge;
